import Matter from 'matter-js';

const DEFAULT_VIEWBOX_SIZE = { width: 100, height: 100 };

export const fetchSvgElement = async (
  svgPath: string,
): Promise<Element | null> => {
  const svgResponse = await fetch(svgPath);
  const svgString = await svgResponse.text();
  const parser = new DOMParser();
  const svgDoc = parser.parseFromString(svgString, 'image/svg+xml');
  return svgDoc.querySelector('svg');
};

export const parseSvgViewBox = (
  svgElement: Element | null,
): { width: number; height: number } => {
  if (!svgElement) {
    return DEFAULT_VIEWBOX_SIZE;
  }

  const viewBox = svgElement.getAttribute('viewBox');
  if (!viewBox) {
    return DEFAULT_VIEWBOX_SIZE;
  }

  const parts = viewBox.split(' ').map(Number);
  if (parts.length >= 4) {
    return { width: parts[2], height: parts[3] };
  }

  return DEFAULT_VIEWBOX_SIZE;
};

export const normalizeAndScaleVertices = (
  vertices: Array<{ x: number; y: number }>,
  svgWidth: number,
  svgHeight: number,
  pngWidth: number,
  pngHeight: number,
): Array<{ x: number; y: number }> => {
  const scaleX = pngWidth / svgWidth;
  const scaleY = pngHeight / svgHeight;

  return vertices.map((v) => ({
    x: v.x * scaleX,
    y: v.y * scaleY,
  }));
};

export const calculateGeometricCenterOfMass = (
  vertices: Array<{ x: number; y: number }>,
): { x: number; y: number } => {
  const centre = Matter.Vertices.centre(vertices);
  return {
    x: centre.x,
    y: centre.y,
  };
};
